import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PROJECTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('PROJECTS');
export const PROJECTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PROJECTS_CRUD_ACTION_CONSTANTS
);
